import { PathPattern } from "react-router";
import {
    Location,
    matchPath,
    NavigateFunction,
    PathMatch,
    useLocation,
    useNavigate,
} from "react-router-dom";

export function withRouter(Child: any) {
    return (props: any) => {
        const location = useLocation();
        const navigate = useNavigate();

        return <Child {...props} location={location} navigate={navigate} matchPath={matchPath} />;
    };
}

export interface WithRouterProps {
    location: Location;
    navigate: NavigateFunction;
    matchPath: (pattern: PathPattern | string, pathname: string) => PathMatch | null;
}
